<div class="container" id="basiPrdPrint" style="height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100%;">
    <div style="width: 100%; font-family: Calibri;">
        <span><h2 class="headerLblcontent">Basic Production</h2></span>
        <!--Header-->
        <div class="row" style="margin: 0px;">
            <div class="col-md-6" style="text-align:left">
                <span class="lableCls">Code : </span><span class="fontstyle">{{xnNo ? xnNo : "-"}}</span><br>
            </div>
            <div class="col-md-6" style="text-align: right;">
                <span class="lableCls">Produced on : </span><span class="fontstyle">{{xnDate | date: 'dd-MMM-yy'}}</span><br>  
                <span class="lableCls">Store : </span><span class="fontstyle">{{storeName}}</span><br>  
            </div>
        </div>
            
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 25px;">
                    <!-- product details -->
                <div class="col-md-12" style="text-align:left;padding: 0px;
                margin-bottom: 10px;">
                    <span class="lableMainHeading"> Production </span>
                </div>
                <table class="table table-bordered">
                    <thead>
                        <tr style="text-align: left;">
                            <th  style="width:25%;">Product</th>
                            <!-- <th style="width: 7%; text-align: right;">Total Qty</th> -->
                            <th style="width: 7%;text-align: right;">Produced Qty</th>
                            <th style="width: 8%;">Unit</th>
                            <th style="width: 15%;">Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of items let i = index">
                            <td>
                                <span>{{i.ItemName}}</span>
                            </td>
                            <!-- <td style="text-align: right;">
                                <span>{{i.StkQty}}</span>
                            </td> -->
                            <td style="text-align: right;">
                                <span>{{i.IQ}}</span>
                            </td>
                            <td>
                                <span>{{i.Unit}}</span>
                            </td>
                            <td>
                                <span *ngIf="i.btchStr != '' && (i.BatchType == 1 || i.BatchType == 2)">Batches : {{i.btchStr}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 25px;">
                <div class="col-md-12" style="text-align:left; padding: 0px;  margin-bottom: 10px;">
                    <span class="lableMainHeading"> Material Consumption </span>
                </div>
    
                <table class="table table-bordered">
                    <thead>
                        <tr style="text-align: left;">
                            <th  style="width:25%;">Material</th>
                            <!-- <th style="width: 7%;text-align: right;">Total Qty</th> -->
                            <th style="width: 7%;text-align: right;">Used Qty</th>
                            <th style="width: 8%;">Unit</th>
                            <th style="width: 15%;">Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let b of bomData let i = index">
                            <td>
                                <span>{{b.ItemName}}</span>
                            </td>
                            <!-- <td style="text-align: right;">
                                <span>{{b.StkQty}}</span>
                            </td> -->
                            <td style="text-align: right;">
                                <span>{{b.OQ}}</span>
                            </td>
                            <td>
                                <span>{{b.Unit}}</span>
                            </td>
                            <td>
                                <span *ngIf="b.btchStr != '' && (b.BatchType == 1 || b.BatchType == 2)">Batches : {{b.btchStr}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
      </div>
</div>
